import React from 'react';
import { Form, FormGroup, Nav, NavItem, NavLink,
  TabContent, TabPane, Row, Col, Input, Button, Badge,
  ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import classnames from 'classnames';
import cloneDeep from 'lodash.clonedeep';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import { FaBars, FaMicroscope, FaPuzzlePiece, FaVial, FaUserGraduate, FaSync,
  FaFlag, FaBook, FaDelicious, FaCalendarAlt, FaCubes, FaCheck, FaPlus,
  FaGripHorizontal, FaEdit, FaClose } from 'react-icons/fa';
import Slider from 'rc-slider';
import Autocomplete from 'react-autocomplete';
import MultiSelect from '../Components/MultiSelect';
import MapsAnalysisDialog from '../Dialogs/MapsAnalysisDialog';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
dayjs.extend(LocalizedFormat)

class FilterPanel extends React.Component {
  constructor(props) {
    super();
    this.state = {
      currentFilterIndex: 0,
      isOpenPresetDateList: false,
      isShowFilteredMaps: false,
      methodsSelected: [],
      componentsSelected: [],
      organismsSelected: [],
      authorSelected: '',
      statusesSelected: [],
      publicationsSelected: [],
      resRange: undefined,
      timeRange: undefined,
      gridRange: undefined,
      dim0Range: undefined,
      filters: [],
    };
    this.dateStart = dayjs('2002-05-25');
    this.dateEnd = dayjs();
    this.filterNames = [
      {
        name: 'EM method', id: 'method', type: 'list', state: 'methodsSelected', icon: (<FaMicroscope size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsEMMethod[i].label).join(', ')).bind(this),
      },
      {
        name: 'Component type', id: 'component', type: 'list', state: 'componentsSelected', icon: (<FaPuzzlePiece size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsComponentType[i].label).join(', ')).bind(this),
      },
      {
        name: 'Source organism', id: 'organism', type: 'list', state: 'organismsSelected', icon: (<FaVial size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsOrganism[i].label).join(', ')).bind(this),
      },
      {
        name: 'Author', id: 'author', type: 'list_m', state: 'authorSelected', icon: (<FaUserGraduate size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsAuthorFull[i].label).join(', ')).bind(this),
      },
      {
        name: 'EMDB status', id: 'status', type: 'list', state: 'statusesSelected', icon: (<FaFlag size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsEMDBStatus[i].label).join(', ')).bind(this),
      },
      {
        name: 'Publications', id: 'publication', type: 'list', state: 'publicationsSelected', icon: (<FaBook size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsPublication[i].label).join(', ')).bind(this),
      },
      {
        name: 'Resolution', id: 'resolution', type: 'range', state: 'resRange', icon: (<FaDelicious size='1.2em'/>),
        toString: (filter => `${filter.range[0]}Å-${filter.range[1]}Å`),
      },
      {
        name: 'Publish date', id: 'date', type: 'range', state: 'timeRange', icon: (<FaCalendarAlt size='1.2em'/>),
        toString: (filter => {
          let t0 = this.dateStart.add(filter.range[0], 'day');
          let t1 = this.dateStart.add(filter.range[1], 'day');
          return `${t0.format('ll')}-${t1.format('ll')}`
        }),
      },
      {
        name: 'Dimension', id: 'dimension', type: 'range', state: 'dim0Range', icon: (<FaCubes size='1.2em'/>),
        toString: (filter => `${filter.range[0]}-${filter.range[1]}`),
      },
      {
        name: 'Papers', id: 'paper', type: 'list', icon: (<FaBook size='1.2em'/>),
        toString: (filter => filter.selection.map(i => this.props.base.optionsPaper[i].label).join(', ')).bind(this),
      },
    ]
  }

  componentWillReceiveProps(nextProps) {
    this.state.filters = nextProps.filters;
  }

  handleMethodsSelectedChanged(methodsSelected) {
    this.setState({methodsSelected});
  }

  handleComponentsSelectedChanged(componentsSelected) {
    this.setState({componentsSelected});
  }

  handleOrganismsSelectedChanged(organismsSelected) {
    this.setState({organismsSelected});
  }

  handleStatusesSelectedChanged(statusesSelected) {
    this.setState({statusesSelected});
  }

  handlePublicationsSelectedChanged(publicationsSelected) {
    this.setState({publicationsSelected});
  }

  handleRefreshClicked() {
    this.applyFilter(this.props, this.state.filters)
  }

  applyFilter(props, filters) {
    props.applyFilter(filters);
  }

  handleAddFilterClicked() {
    let filters = this.state.filters;
    let filterName = this.filterNames[this.state.currentFilterIndex];
    if(filterName.type === 'list') {
      if(this.state[filterName.state].length) {
        filters[this.state.currentFilterIndex] = {
          selection: this.state[filterName.state],
        }
      }
      else delete filters[this.state.currentFilterIndex];
    }
    else if(filterName.type === 'list_m') {
      let index = this.props.base.optionsAuthorFull.findIndex((a => a.label === this.state.authorSelected).bind(this));
      if(index >= 0) {
        if(this.props.base.listAuthorFull[index].mergeTo) {
          let nameNew = this.props.base.listAuthorFull[index].mergeTo;
          index = this.props.base.optionsAuthorFull.findIndex(a => a.label === nameNew);
        }
        if(!filters[this.state.currentFilterIndex]) {
          filters[this.state.currentFilterIndex] = {selection: [index]};
        }
        else if(filters[this.state.currentFilterIndex].selection.indexOf(index) < 0) {
          filters[this.state.currentFilterIndex].selection.push(index);
        }
        this.setState({authorSelected: ''});
      }
      // TODO: 提示找不到该作者
    }
    else if(filterName.type === 'range') {
      if(this.state[filterName.state]) {
        filters[this.state.currentFilterIndex] = {
          range: this.state[filterName.state],
        }
      }
      else delete filters[this.state.currentFilterIndex];
    }
    this.setState({filters});
    this.applyFilter(this.props, filters);
  }

  handleRemoveFilterClicked(fidx) {
    let filters = this.state.filters;
    delete filters[fidx];
    this.setState({filters});
    this.applyFilter(this.props, filters);
  }

  handleClearFilterClicked() {
    this.setState({filters: []});
    this.applyFilter(this.props, []);
  }

  toggleFilterIndex = ((currentFilterIndex) => {
    this.setState({ currentFilterIndex });
  }).bind(this);

  toggleFilterTypeList = (() => {
    this.setState({ isOpenFilterTypeList: !this.state.isOpenFilterTypeList });
  }).bind(this);

  togglePresetDateList = (() => {
    this.setState({ isOpenPresetDateList: !this.state.isOpenPresetDateList });
  }).bind(this);

  toggleShowFilteredMaps = (() => {
    this.setState({ isShowFilteredMaps: !this.state.isShowFilteredMaps });
  }).bind(this);

  drill = (selections => {
    let filters = this.state.filters;
    let changed = false;
    this.filterNames.forEach((fname, index) => {
      let sels = selections[fname.id];
      if(!sels || !sels.length)
        return;
      // publication & paper filter should select one
      if(index === 5)
        delete filters[9];
      if(index === 9)
        delete filters[5];
      // apply filter
      filters[index] = {selection: sels};
      changed = true;
    })
    if(changed) {
      this.applyFilter(this.props, filters);
      this.setState({filters});
    }
  })

  matchAuthorToTerm(author, value) {
    return value.length ? (
      author.label.toLowerCase().indexOf(value.toLowerCase()) !== -1
    ) : false;
  }

  sortAuthors(a, b, value) {
    const aLower = a.label.toLowerCase()
    const bLower = b.label.toLowerCase()
    const valueLower = value.toLowerCase()
    const queryPosA = aLower.indexOf(valueLower)
    const queryPosB = bLower.indexOf(valueLower)
    if (queryPosA !== queryPosB) {
      return queryPosA - queryPosB
    }
    return aLower < bLower ? -1 : 1
  }

  setResolutionRange = (resRange => {
    if(resRange[0] <= this.props.base.overviewEMDs.resMin &&
      resRange[1] >= this.props.base.overviewEMDs.resMax)
      resRange = undefined;
    this.setState({resRange});
  }).bind(this);

  setReleaseDateRange = (timeRange => {
    let timeRangeMax = this.dateEnd.diff(this.dateStart, 'day');
    if(timeRange[0] < 0 && timeRange[1] >= timeRangeMax)
      timeRange = undefined;
    else {
      if(timeRange[0] < 0)
        timeRange[0] = 0;
      if(timeRange[1] >= timeRangeMax)
        timeRange[1] = timeRangeMax-1;
    }
    this.setState({timeRange});
  }).bind(this);

  setGridPointNumberRange = (gridRange => {
    if(gridRange[0] <= this.props.base.overviewEMDs.gridMin &&
      gridRange[1] >= this.props.base.overviewEMDs.gridMax)
      gridRange = undefined;
    this.setState({gridRange});
  }).bind(this);

  setDimensionRange = (dim0Range => {
    if(dim0Range[0] <= this.props.base.overviewEMDs.dim0Min &&
      dim0Range[1] >= this.props.base.overviewEMDs.dim0Max)
      dim0Range = undefined;
    this.setState({dim0Range});
  }).bind(this);

  tagJoin(arr, sep) {
    let arr1 = []
    for(let i=0; i<arr.length; ++i) {
      arr1.push(arr[i]);
      arr1.push(sep);
    }
    return arr1;
  }

  cropString = (str, len) => {
    if (str.length <= len)
      return str;
    let strHead = str.slice(0, len);
    let cropPoint = strHead.lastIndexOf(',');
    return strHead.slice(0, cropPoint + 1) + '...';
  }

  filteredNumberSummary = () => {
    let {filterResults} = this.props.filtered;
    let filteredNumber = filterResults ? filterResults.length : 0;
    return `(${filteredNumber} item${filteredNumber > 1 ? 's' : ''} found)`
  }

  render() {
    let timeRangeMax = this.dateEnd.diff(this.dateStart, 'day');
    return (
      <div>
        <Row>
          <Col xs={2}>
            <ButtonDropdown className='full-width' isOpen={this.state.isOpenFilterTypeList} toggle={this.toggleFilterTypeList}>
              <DropdownToggle color="primary" caret size="sm">
                {this.filterNames[this.state.currentFilterIndex].icon} {this.filterNames[this.state.currentFilterIndex].name}
              </DropdownToggle>
              <DropdownMenu>
                {this.filterNames.map((f, fidx) => (
                  f.state && <DropdownItem onClick={() => { this.toggleFilterIndex(fidx); }}>{f.icon} {f.name}</DropdownItem>
                )).filter(m => m)}
              </DropdownMenu>
            </ButtonDropdown>
          </Col>
          <Col xs={9}>
            <TabContent activeTab={this.filterNames[this.state.currentFilterIndex].id}>
              <TabPane tabId="method">
                <MultiSelect
                  className="filters"
                  options={this.props.base.optionsEMMethod}
                  onSelectedChanged={this.handleMethodsSelectedChanged.bind(this)}
                  selected={this.state.methodsSelected}
                  overrideStrings={{
                    selectSomeItems: "EM method",
                    allItemsAreSelected: "All Items are Selected",
                    selectAll: "Select All",
                    search: "Search",
                  }}
                />
              </TabPane>
              <TabPane tabId="component">
                <MultiSelect
                  className="filters"
                  options={this.props.base.optionsComponentType}
                  onSelectedChanged={this.handleComponentsSelectedChanged.bind(this)}
                  selected={this.state.componentsSelected}
                  overrideStrings={{
                    selectSomeItems: "Component type",
                    allItemsAreSelected: "All Items are Selected",
                    selectAll: "Select All",
                    search: "Search",
                  }}
                />
              </TabPane>
              <TabPane tabId="organism">
                <MultiSelect
                  className="filters"
                  options={this.props.base.optionsOrganism}
                  onSelectedChanged={this.handleOrganismsSelectedChanged.bind(this)}
                  selected={this.state.organismsSelected}
                  overrideStrings={{
                    selectSomeItems: "Source organism",
                    allItemsAreSelected: "All Items are Selected",
                    selectAll: "Select All",
                    search: "Search",
                  }}
                />
              </TabPane>
              <TabPane tabId="author">
                <Autocomplete
                  inputProps={{ className: 'full-width', placeholder: ' Author' }}
                  wrapperStyle={{ width: '100%' }}
                  getItemValue={(item) => item.label}
                  items={this.props.base.optionsAuthorFull}
                  shouldItemRender={this.matchAuthorToTerm}
                  sortItems={this.sortAuthors}
                  renderItem={(item, isHighlighted) =>
                    <div style={{ background: isHighlighted ? 'lightgray' : 'white' }}>
                      {item.label}
                    </div>
                  }
                  menuStyle={{
                    borderRadius: '3px',
                    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
                    background: 'rgba(255, 255, 255, 0.9)',
                    padding: '2px 0',
                    fontSize: '90%',
                    position: 'fixed',
                    overflow: 'auto',
                    maxHeight: '50%',
                    'z-index': '999'
                  }}
                  value={this.state.authorSelected}
                  onChange={(e) => {
                    this.setState({authorSelected: e.target.value});
                  }}
                  onSelect={(val) => {
                    this.setState({authorSelected: val});
                  }}
                />
              </TabPane>
              <TabPane tabId="status">
                <MultiSelect
                  className="filters"
                  options={this.props.base.optionsEMDBStatus}
                  onSelectedChanged={this.handleStatusesSelectedChanged.bind(this)}
                  selected={this.state.statusesSelected}
                  overrideStrings={{
                    selectSomeItems: "EMDB status",
                    allItemsAreSelected: "All Items are Selected",
                    selectAll: "Select All",
                    search: "Search",
                  }}
                />
              </TabPane>
              <TabPane tabId="publication">
                <MultiSelect
                  className="filters"
                  options={this.props.base.optionsPublication}
                  onSelectedChanged={this.handlePublicationsSelectedChanged.bind(this)}
                  selected={this.state.publicationsSelected}
                  overrideStrings={{
                    selectSomeItems: "Publications",
                    allItemsAreSelected: "All Items are Selected",
                    selectAll: "Select All",
                    search: "Search",
                  }}
                />
              </TabPane>
              <TabPane tabId="resolution">
                <Row className='slider'>
                  <Col xs={12}>
                    <Range
                      min={this.props.base.overviewEMDs.resMin}
                      max={this.props.base.overviewEMDs.resMax}
                      value={this.state.resRange ? this.state.resRange : [this.props.base.overviewEMDs.resMin, this.props.base.overviewEMDs.resMax]}
                      onChange={this.setResolutionRange}
                    />
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="date">
                <Row className='slider'>
                  <Col xs={6}>
                    <Range
                      ref={ref => this.dateRangeSlider = ref}
                      min={0}
                      max={timeRangeMax}
                      value={this.state.timeRange ? this.state.timeRange : [0, timeRangeMax]}
                      tipFormatter={value => this.dateStart.add(value, 'day').format('ll')}
                      onChange={this.setReleaseDateRange}
                    />
                  </Col>
                  <Col xs={2} style={{margin: '-5px 5px 0px 15px'}}>
                    <Input
                      type="date"
                      size="sm"
                      name="startDate"
                      id="startDate"
                      onChange={(e) => {
                        let {timeRange} = this.state;
                        if(!timeRange) timeRange = [0, timeRangeMax];
                        timeRange[0] = dayjs(e.target.value).diff(this.dateStart, 'day');
                        if(isNaN(timeRange[0]) || timeRange[0] < 0 || timeRange[0] >= timeRangeMax)
                          timeRange[0] = 0;
                        this.setReleaseDateRange(timeRange);
                      }}
                      value={(this.state.timeRange ? this.dateStart.add(this.state.timeRange[0], 'day') : this.dateStart).format('YYYY-MM-DD')}
                    />
                  </Col>
                  <Col xs={2} style={{margin: '-5px 15px 0px 5px'}}>
                    <Input
                      type="date"
                      size="sm"
                      name="enddate"
                      id="enddate"
                      onChange={(e) => {
                        let {timeRange} = this.state;
                        if(!timeRange) timeRange = [0, timeRangeMax];
                        timeRange[1] = dayjs(e.target.value).diff(this.dateStart, 'day');
                        if(isNaN(timeRange[1]) || timeRange[1] < 0 || timeRange[1] >= timeRangeMax)
                          timeRange[1] = timeRangeMax;
                        this.setReleaseDateRange(timeRange);
                      }}
                      value={(this.state.timeRange ? this.dateStart.add(this.state.timeRange[1], 'day') : this.dateEnd).format('YYYY-MM-DD')}
                    />
                  </Col>
                  <Col style={{margin: '-5px 5px 0px 5px'}}>
                    <ButtonDropdown className='full-width' isOpen={this.state.isOpenPresetDateList} toggle={this.togglePresetDateList}>
                      <DropdownToggle caret size="sm">
                        Presets
                      </DropdownToggle>
                      <DropdownMenu>
                        {[2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019].map((year, yidx) => (
                          <DropdownItem onClick={() => {
                            this.setReleaseDateRange([dayjs(`${year}-01-01`).diff(this.dateStart, 'day'),
                              dayjs(`${year}-12-31`).diff(this.dateStart, 'day')]);
                          }}>Year {year}</DropdownItem>
                        ))}
                      </DropdownMenu>
                    </ButtonDropdown>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="dimension">
                <Row className='slider'>
                  <Col xs={12}>
                    <Range
                      min={this.props.base.overviewEMDs.dim0Min}
                      max={this.props.base.overviewEMDs.dim0Max}
                      value={this.state.dim0Range ? this.state.dim0Range : [this.props.base.overviewEMDs.dim0Min, this.props.base.overviewEMDs.dim0Max]}
                      onChange={this.setDimensionRange}
                    />
                  </Col>
                </Row>
              </TabPane>
            </TabContent>
          </Col>
          <Col xs={1} style={{ display: 'flex', 'justify-content': 'flex-end' }}>
            <Button color="primary" size="sm" style={{ width: '40px', margin: '0 auto' }}
              onClick={this.handleAddFilterClicked.bind(this)}
            >{this.filterNames[this.state.currentFilterIndex].type === 'list_m' ? <FaPlus size='1.2em' /> : <FaCheck size='1.2em' />}</Button>
            <Button color="primary" size="sm" style={{ width: '40px', margin: '0 auto' }}
              onClick={this.handleClearFilterClicked.bind(this)}
            ><FaSync size='1.2em' /></Button>
            <Button color="primary" size="sm" style={{ width: '40px', margin: '0 auto' }}
              onClick={this.props.onMapAnalyze ? (() => this.props.onMapAnalyze(this.props.filtered.filterResults)) : this.toggleShowFilteredMaps}
            ><FaGripHorizontal size='1.2em' /></Button>
            {this.state.isShowFilteredMaps && <MapsAnalysisDialog
              base={this.props.base}
              maps={this.props.filtered.filterResults}
              toggle={this.toggleShowFilteredMaps}
              onEMDSelected={this.props.onEMDSelected}
              onDrill={this.props.onDrill}
            />}
          </Col>
        </Row>
        <Row className='row-new'>
          <Col>
            {
              this.state.filters.length ? (<div>
                {this.tagJoin(this.state.filters.map((f, fidx) => (
                  <ButtonDropdown
                    isOpen={this.state[`isOpenMenuFilter${fidx}`]}
                    toggle={() => this.setState({[`isOpenMenuFilter${fidx}`]: !this.state[`isOpenMenuFilter${fidx}`]})}
                  >
                    <DropdownToggle className='filter-dropdown' color="secondary" caret size="sm">
                      {this.filterNames[fidx].icon}{' : ' + this.cropString(this.filterNames[fidx].toString(f), 230)}
                    </DropdownToggle>
                    <DropdownMenu>
                      <DropdownItem
                        onClick={() => { this.handleRemoveFilterClicked(fidx); }}>Remove
                      </DropdownItem>
                    </DropdownMenu>
                  </ButtonDropdown>
                )), ' ')}
                <br /><i>{this.filteredNumberSummary()}</i>
              </div>) : <i>No filter. {this.filteredNumberSummary()}</i>
            }
          </Col>
        </Row>
      </div>
    )
  }
}

export default FilterPanel;
